module.exports = __webpack_public_path__ + "static/img/6293_phase_function_Paper_PointsHejduk_Prediction.6f4298f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6293_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /l60
// module chunks = 0